import type { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SurfaceContextProvider } from '@clds/design-system-foundations';
import { layoutCommon } from './layoutCommon';

const Root = styled.div`
  ${layoutCommon};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${(props) => props.theme.spacing.xxs} 0;
  margin-bottom: ${(props) => props.theme.spacing.xs};
`;

export const GuestBarLayoutDesktop: FC<{ children?: ReactNode }> = (props) => (
  <SurfaceContextProvider variant="error" tone="solid">
    <Root mode="solidContrast" variant="error" intensity="md" {...props} />
  </SurfaceContextProvider>
);
